import React from 'react';
// import { WindowContainer, WindowText } from './styles';
// import ok from '../../../assets/icons/ok.svg';
// import attention from '../../../assets/icons/attention.svg';

export const Window = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    textArr, isGood, isShow,
  } = props;
  return (
    <></>
  );
};
/*
    <WindowContainer isShow={isShow} isGood={isGood}>
      <img src={isGood ? ok : attention}/>
      <WindowText isGood={isGood}>
        {
          textArr
          // eslint-disable-next-line react/prop-types
          && textArr.map((item, i) => <p key={i}>{item}</p>)
        }
      </WindowText>
    </WindowContainer>

 */
